/**
 * @module Utilities/Helpers
 * @desc Helpers helper funtions
 */

import { getSearchParams } from './get-search-params';

/**
 * Checks if has a redirect url from url search params
 */
export function hasReturnUrl() {
  const searchParams = getSearchParams();

  return searchParams.has('returnUrl');
}
